<h4 class="page-title">  <i class="far fa-building"></i>
  Loja</h4>

<div class="alert alert-warning" role="alert" *ngIf="erroNavegacao">{{erroNavegacao}}</div>
<app-chamada-recurso-contextual
  slug="dominio_proprio"
  origem="loja"
  titulo="Um endereço com a cara da sua marca"
  descricao="Divulgue seu cardápio usando um domínio próprio."
  icone="fa-globe">
</app-chamada-recurso-contextual>

<div class="card vertical-tabstrip">
  <div class="card-box">
    <kendo-tabstrip #tabstrip (tabSelect)="selecionouAba($event)"  [scrollable]="{ scrollButtons: 'visible' }"
                    [style.width.%]="100">
      <ng-container *ngIf="podeGerenciarLoja()">
      <kendo-tabstrip-tab [selected]="true" title="Formas de entrega">
        <ng-template kendoTabTitle>
          <i class="fas fa-truck mr-2"></i>
          Formas de entrega
        </ng-template>
        <ng-template kendoTabContent>
          <app-form-formasdeentrega #frmFormaEntrega [empresa]="empresa" ></app-form-formasdeentrega>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab  id="horarios" [title]="nomeTabHorario" >
        <ng-template kendoTabTitle>
          <i class="fas fa-clock mr-2"></i>
          {{nomeTabHorario}}
        </ng-template>
        <ng-template kendoTabContent>
          <h4>Horário de funcionamento</h4>

          <p>Configure os dias e horários da loja </p>

          <div class="form-group mb-2  " style="max-width: 350px">
            <label  >Fuso Horário</label>

            <kendo-combobox   name="fusoHorario" [data]="fusos"   (valueChange)="selecionouFuso()"
                              class="form-control"     [allowCustom]="false" [required]="true"
                              #cbFusoHorario="ngModel" [(ngModel)]="fusoHorario"
                              [textField]="'descricao'">
            </kendo-combobox>
          </div>


          <kendo-tabstrip   class="nav-bordered horarios " #tabHorarios (tabSelect)="selecionouAbaHorarios($event)"    [scrollable]="{ scrollButtons: 'visible' }"  >
            <kendo-tabstrip-tab [selected]="true">
              <ng-template kendoTabTitle>
                <i class="fas fa-business-time mr-2"></i>
                Horários da loja para pedidos
              </ng-template>
              <ng-template kendoTabContent>
                <app-cad-horariosfuncionamentonova   [empresa]="empresa"></app-cad-horariosfuncionamentonova>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab>
              <ng-template kendoTabTitle>
                <i class="fas fa-pause-circle mr-2"></i>
                Pausa Programada
              </ng-template>
              <ng-template kendoTabContent>
                <app-tela-pausas-programadas [empresa]="empresa"></app-tela-pausas-programadas>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>

        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab *ngIf="possuiCardapioOuPedidos()" title="Cardápio">
        <ng-template kendoTabTitle>
          <i class="fas fa-utensils mr-2"></i>
          Cardápio
        </ng-template>
        <ng-template kendoTabContent>
          <app-upload-cardapio [empresa]="empresa"></app-upload-cardapio>
        </ng-template>
      </kendo-tabstrip-tab>

      <!-- NOVA ABA: CAIXA -->
      <kendo-tabstrip-tab *ngIf="recursoAtivo('caixa')" title="Caixa">
        <ng-template kendoTabTitle>
          <i class="fas fa-cash-register mr-2"></i>
          Caixa
        </ng-template>
        <ng-template kendoTabContent>
          <app-configuracoes-modulo-caixa [empresa]="empresa"></app-configuracoes-modulo-caixa>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab *ngIf="possuiPedidosOuMesas() && (recursoAtivo('impressao_avancada') || possuiModuloKDS)" [title]="nomeTabImpressao">
        <ng-template kendoTabTitle>
          <i class="fas fa-print mr-2"></i>
          {{nomeTabImpressao}}
        </ng-template>
        <ng-template kendoTabContent>
          <app-tab-areas-destinos [empresa]="empresa" [possuiModuloKDS]="possuiModuloKDS"
                                  [possuiModuloFiscal]="possuiModuloFiscal"
                                  [possuiRecursoImpressaoAutomatica]="recursoAtivo('impressao_avancada')" ></app-tab-areas-destinos>

        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab id="formaspagamento" [title]="nomeTabFormasPagamento" *ngIf="moduloAtivo('pedidos')">
        <ng-template kendoTabTitle>
          <i class="fas fa-credit-card mr-2"></i>
          {{nomeTabFormasPagamento}}
        </ng-template>
        <ng-template kendoTabContent>
          <app-ativar-formas-de-pagamento  *ngIf="empresa.exibirBandeiras"></app-ativar-formas-de-pagamento>

          <app-cadastro-formas-de-pagamento *ngIf="!empresa.exibirBandeiras"></app-cadastro-formas-de-pagamento>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Mesas" *ngIf="moduloAtivo('mesas_garcom')">
        <ng-template kendoTabTitle>
          <i class="fas fa-table mr-2"></i>
          Mesas
        </ng-template>
        <ng-template kendoTabContent>
          <app-tela-config-mesas></app-tela-config-mesas>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Cupons" *ngIf="moduloAtivo('pedidos') && recursoAtivo('cupons_avancados')">
        <ng-template kendoTabTitle>
          <i class="fas fa-ticket-alt mr-2"></i>
          Cupons
        </ng-template>
        <ng-template kendoTabContent>
          <app-tela-cupons [exibirTitulo]="false"></app-tela-cupons>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Promoções" *ngIf="moduloAtivo('pedidos') && recursoAtivo('cupons_avancados')">
        <ng-template kendoTabTitle>
          <i class="fas fa-percent mr-2"></i>
          Promoções
        </ng-template>
        <ng-template kendoTabContent>
          <app-tela-promocoes [exibirTitulo]="false"></app-tela-promocoes>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Adicionais de Pedido">
        <ng-template kendoTabTitle>
          <i class="fas fa-plus-circle mr-2"></i>
          Adicionais De Pedido
        </ng-template>
        <ng-template kendoTabContent>
          <app-cad-adicionais-pedido></app-cad-adicionais-pedido>
        </ng-template>
      </kendo-tabstrip-tab>
      </ng-container>

      <kendo-tabstrip-tab *ngIf="possuiModuloPagamentosEletronicos()">
        <ng-template kendoTabTitle>
          <i class="fas fa-credit-card mr-2"></i>
          Pagamentos Eletrônicos
        </ng-template>
        <ng-template kendoTabContent>
          <app-configuracao-pagamentos-eletronicos></app-configuracao-pagamentos-eletronicos>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="nomeTabUsuarios" [selected]="!podeGerenciarLoja()" *ngIf="podeGerenciarUsuariosLoja()">
        <ng-template kendoTabTitle>
          <i class="fas fa-users mr-2"></i>
          {{nomeTabUsuarios}}
        </ng-template>
        <ng-template kendoTabContent>
          <app-usuarios-empresa *ngIf="empresa" [empresa]="empresa"></app-usuarios-empresa>
        </ng-template>
      </kendo-tabstrip-tab>

      <ng-container *ngIf="podeGerenciarLoja()">
      <kendo-tabstrip-tab *ngIf="moduloAtivo('pedidos') && moduloAtivo('fidelidade')" title="Fidelidade">
        <ng-template kendoTabTitle>
          <i class="fas fa-star mr-2"></i>
          Fidelidade
        </ng-template>
        <ng-template kendoTabContent>

          <kendo-tabstrip #tabFidelidade (tabSelect)="selecionouAbaFidelidade($event)" class="nav-bordered fidelidade "   >
            <kendo-tabstrip-tab [selected]="true">
              <ng-template kendoTabTitle>
                <i class="fas fa-store-alt mr-2"></i>
                Integração com Loja
              </ng-template>
              <ng-template kendoTabContent>
                <app-form-integracaofidelidade [usuario]=usuario [empresa]="empresa"></app-form-integracaofidelidade>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab>
              <ng-template kendoTabTitle>
                <i class="fas fa-layer-group mr-2"></i>
                Planos
              </ng-template>
              <ng-template kendoTabContent>
                <app-planos [empresa]="empresa"></app-planos>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab>
              <ng-template kendoTabTitle>
                <i class="fas fa-tasks mr-2"></i>
                Atividades
              </ng-template>
              <ng-template kendoTabContent>
                <app-atividades [empresa]="empresa"></app-atividades>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab>
              <ng-template kendoTabTitle>
                <i class="fas fa-gift mr-2"></i>
                Brindes
              </ng-template>
              <ng-template kendoTabContent>
                <app-brindes [empresa]="empresa"></app-brindes>
              </ng-template>
            </kendo-tabstrip-tab>

          </kendo-tabstrip>

        </ng-template>
      </kendo-tabstrip-tab>

      <ng-container *ngIf="moduloAtivo('pedidos')  ">
        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_pdv_parceiros')"  [title]="'Integração com Pdv'" >
          <ng-template kendoTabTitle>
            <i class="fas fa-cash-register mr-2"></i>
            Integração com Pdv
          </ng-template>
          <ng-template kendoTabContent>
            <app-form-integracaopedidos  [empresa]="empresa"></app-form-integracaopedidos>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_delivery_parceiros')" [title]="'Integração com Delivery'" >
          <ng-template kendoTabTitle>
            <i class="fas fa-motorcycle mr-2"></i>
            Integração com Delivery
          </ng-template>
          <ng-template kendoTabContent>
            <app-form-integracaodelivery  [empresa]="empresa"></app-form-integracaodelivery>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_marketplaces_delivery')" [title]="nomeTabIfood"   >
          <ng-template kendoTabTitle>
            <i class="fas fa-store mr-2 text-danger"></i>
            {{nomeTabIfood}}
          </ng-template>
          <ng-template kendoTabContent>
            <app-tela-integracao-ifood  [empresa]="empresa"></app-tela-integracao-ifood>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_marketplaces_delivery')" [title]="nomeTabKeeta"   >
          <ng-template kendoTabTitle>
            <i class="fas fa-store mr-2" style="    color: #13ce9d !important;"></i>
            {{nomeTabKeeta}}
          </ng-template>
          <ng-template kendoTabContent>
            <app-tela-integracao-keeta  [empresa]="empresa"></app-tela-integracao-keeta>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_marketplaces_delivery')" [title]="nomeTab99Food"   >
          <ng-template kendoTabTitle>
            <i class="fas fa-store mr-2" style="    color: #fedc33 !important;"></i>
            {{nomeTab99Food}}
          </ng-template>
          <ng-template kendoTabContent>
            <app-tela-integracao-99food  [empresa]="empresa"></app-tela-integracao-99food>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab *ngIf="recursoAtivo('integracao_marketplaces_delivery')" [title]="nomeTabOpenDelivery">
          <ng-template kendoTabTitle>
            <i class="fas fa-store mr-2" style="    color: #000 !important;"></i>
            {{nomeTabOpenDelivery}}
          </ng-template>
          <ng-template kendoTabContent>
            <app-tela-integracao-opendelivery-ss [empresa]="empresa"></app-tela-integracao-opendelivery-ss>
          </ng-template>
        </kendo-tabstrip-tab>

      </ng-container>

      <kendo-tabstrip-tab title="Fotos">
        <ng-template kendoTabTitle>
          <i class="fas fa-images mr-2"></i>
          Fotos
        </ng-template>
        <ng-template kendoTabContent>
          <app-fotos #appFotos   [empresa]="empresa" [fotosDoAmbiente]="false"></app-fotos>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Banners">
        <ng-template kendoTabTitle>
          <i class="fas fa-layer-group mr-2"></i>
          Banners
        </ng-template>
        <ng-template kendoTabContent>
          <app-tela-cadastro-banner></app-tela-cadastro-banner>
        </ng-template>
      </kendo-tabstrip-tab>
      </ng-container>
    </kendo-tabstrip>
  </div>
</div>
